export enum Role {
  /**
   * Organisation admins have full access to all resources within the organisation.
   * Including billing and payment information.
   * Must be at least one org admin at all times.
   */
  ORG_ADMIN = 'org_admin',

  /**
   * The organisation write role allows users to create and update groups and users within
   * the organisation. (But no access to billing or payment information)
   */
  ORG_WRITE = 'org_write',

  /**
   * The organisation read role allows users to view the organisation and its members.
   * (But no access to billing or payment information)
   */
  ORG_READ = 'org_read',

  /**
   * Project admins have full access to all resources within the project. Can manage
   * project members and shares.
   */
  PROJECT_ADMIN = 'project_admin',

  /**
   * The project write role allows users to create and update resources within the project.
   * But cannot manage project members.
   * They can manage shared resources.
   */
  PROJECT_WRITE = 'project_write',

  /**
   * The project read role allows users to view resources within the project.
   */
  PROJECT_READ = 'project_read',
}
